import _ from 'lodash'
import i18n from '@/core/localization/i18n'
import Vue from 'vue'

const state = {
  languages: null,
  units: null,
  configuration: null,
  templates: null,
  settings: null
}

const actions = {
  setStaticData({ commit }, payload) {
    commit('set_static_data', payload)
  }
}

const mutations = {
  set_static_data(state, payload) {
    Vue.set(state, payload.key, payload.data)
  }
}

const getters = {
  languages: state => state.languages,
  companies: state => {
    const companies = _.keyBy(state.companies, '_nodeId')
    const subUnits = _.chain(state.companies).flatMap('mergedSubUnits').keyBy('_nodeId').value()
    return { ...companies, ...subUnits }
  },
  templates: state => state.templates,
  configuration: state => state.configuration,
  settings: state => state.settings,
  workTypes: state => _.get(state.settings, [i18n.locale, 'workTypes'], [])
}

export default {
  state,
  actions,
  mutations,
  getters
}
